export const formatCurrency = (value: number) =>
    new Intl.NumberFormat(`en-US`, {
        currency: `USD`,
        style: 'currency',
    }).format(value);

export const floorToTwoDecimals = (value: number) => _.floor(value, 2);

export const convertToNumber = (value: any) => _.isNil(value) ? undefined : Number(value);
